import { Injectable } from '@angular/core';
import { ApiService } from '../API/api.service';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MLOService {

  constructor(public apiService: ApiService) { }

  private messageSource = new BehaviorSubject({});
  currentEditMLO = this.messageSource.asObservable();
  
  private closedMlcs = new BehaviorSubject({});
  currentEditClosedMLO = this.closedMlcs.asObservable();

  private mlcDetailsById = new BehaviorSubject({});
  getMlcDetailsById = this.mlcDetailsById.asObservable();

  private mlcId = new BehaviorSubject({});
  getMlcId = this.mlcId.asObservable();

  
  changeEditMLO(data: any) {
    this.messageSource.next(data)
  }

  changeEditClosedMlcs(data: any) {
     this.closedMlcs.next(data);
  }

  setMlcDetailsById(data : any) {
    this.mlcDetailsById.next(data)
  }
  
  setMlcId(data: any) {
    this.mlcId.next(data)
  }

  getAllMLOs(body : any): Observable<any> {
    return this.apiService.post('mlo/getMLCs', body)
  }

  addMLO(body : any): Observable<any> {
    return this.apiService.post('mlo/createMLC', body);
  }

  editMLO(body : any): Observable<any> {
    return this.apiService.post('mlo/editMLC', body);
  }
  
  getInternalCode(body: any): Observable<any> {
    return this.apiService.post('mlo/beforeMLCCreation', body);
  }

  inActivateMLC(body : any): Observable<any> {
    return this.apiService.post('mlo/inActivateMLC', body);
  }

  startMLC(body : any): Observable<any> {
    return this.apiService.post('mlo/startMLC', body);
  }

  closeMLC(body : any): Observable<any> {
    return this.apiService.post('mlo/closeMLC', body);
    // return this.apiService.post('mlo/closeMlcUserAction', body);
  }

  getAllOlderMlcs(body : any): Observable<any> {
    return this.apiService.post('', body);
  }
  getMlcById(body : any): Observable<any> {
    return this.apiService.post('mlo/getMLCbyId', body);
  }
  getAllClosedMlcs(body : any): Observable<any> {
    return this.apiService.post('mlo/getClosedMlcs', body);
  }
  getClosedMlcById(body : any): Observable<any> {
    return this.apiService.post('mlo/getClosedMLCbyId', body);
  }
  activateClosedMLC(body : any): Observable<any> {
    return this.apiService.post('mlo/activateMLC', body);
  }
  editClosedMlcs(body : any): Observable<any> {
    return this.apiService.post('', body);
  }
  getMlcByIdWithReleaseData(body : any): Observable<any> {
    return this.apiService.post('mlo/getMLCwithReleaseData', body);
  }
  getFormulaAndMlcs(body : any): Observable<any> {
    return this.apiService.post('mlo/getFormulaAndMlcs', body);
  }
  getFormulaByIdForReleaseData(body : any): Observable<any> {
    return this.apiService.post('formulations/getFormulaByIdForReleaseMaterial', body);
  }
  sendMailWhenCreateMLC(body : any): Observable<any> {
  return this.apiService.post('mlo/sendMailwhenCreateMLC', body);
  }
  sendMailtoWarehouseUsers(body : any): Observable<any> {
    return this.apiService.post('mlo/sendMailtoWarehouseControllers', body);
  }

  getCloseMlcUserAction(body : any): Observable<any> {
    return this.apiService.post('mlo/closeMlcUserAction', body);
  }
}
